<template>
  <div>

    <b-field label="Statut du projet">
      <b-select
          placeholder="Tous"
          v-model="selectedStatusProject"
          @input="action">
        <option
            v-for="option in data"
            :value="option.value"
            :key="option.value">
          {{ option.lib }}
        </option>
      </b-select>
    </b-field>

    </div>
</template>

<script>

export default {
  name: "SelectStatusProject",
  mounted() {
  },
  computed: {
  },
  watch: {
  },
  methods: {

    action(option) {
      this.selectedStatusProject = option
      this.$emit('updateStatusProject', option);
    }

  },
  data() {
    return {
      data: [
        {value: 0, lib: "Tous"},
        {value: 1, lib: "Nouveau"},
        {value: 2, lib: "En cours"},
        {value: 3, lib: "Terminé "},
        {value: 4, lib: "Annulé"},
      ],
      selectedStatusProject: 2
    }
  }
}
</script>

<style scoped>

</style>
